import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { ProductDetails } from '@models';
import { AccessibleClickDirective } from 'libs/shared/src/lib/directives/accessible-click.directive';
import { ImageFallbackDirective } from 'libs/shared/src/lib/directives/image-fallback.directive';

@Component({
    selector: 'lib-light-carousel',
    templateUrl: './light-carousel.component.html',
    styleUrls: ['./light-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AccessibleClickDirective, ImageFallbackDirective]
})
export class LightCarouselComponent {
  images = input<ProductDetails['images']>([]);
  label = input<string>();
  isShiftedDownControls = input(false);

  currentSlide = signal(0);

  private touchStartX = signal(0);
  private touchEndX = signal(0);

  translateX = computed(() => `translateX(calc(-100% * ${this.currentSlide()}))`);

  nextSlide(): void {
    if (this.currentSlide() < this.images().length - 1) {
      this.currentSlide.set(this.currentSlide() + 1);
    }
  }

  previousSlide(): void {
    if (this.currentSlide() > 0) {
      this.currentSlide.set(this.currentSlide() - 1);
    }
  }

  setCurrentSlide(index: number): void {
    this.currentSlide.set(index);
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX.set(event.touches[0].clientX);
  }

  onTouchMove(event: TouchEvent): void {
    this.touchEndX.set(event.touches[0].clientX);
  }

  onTouchEnd(): void {
    if (this.touchEndX() < this.touchStartX()) {
      this.nextSlide();
    } else if (this.touchEndX() > this.touchStartX()) {
      this.previousSlide();
    }
  }
}
